define('SageDotCom/Components/SlickSliderSettings',[], function () {
    function SlickSliderSettings() { }

    //slick settings for default score slick slider
    SlickSliderSettings.prototype.getSlickSliderSettings = function getSlickSliderSettings(args) {
        var slidesToShowDesktop = args ? args.SlidesToShow : null;
        var promoBar = args ? args.scope.classList.contains("promoBar") : false;
        var condensed = args ? args.scope.classList.contains("slider-condensed") : false;
        //if not filled in use defaults
        if ((slidesToShowDesktop == 0 || slidesToShowDesktop == null) && promoBar || condensed) {
            slidesToShowDesktop = 4;
        } else if (slidesToShowDesktop == 0 || slidesToShowDesktop == null) {
            slidesToShowDesktop = 3;
        } 

        var deviceSlides = this.getNumOfSlidesPerDevice(slidesToShowDesktop);

        return this.getSettingsObject(deviceSlides.slidesToShowDesktop, deviceSlides.slidesToShowTablet, deviceSlides.slidesToShowMobile, 0);
    }
    SlickSliderSettings.prototype.getSlickSliderSettingsNumOfSlidesOnly = function getSlickSliderSettings(slidesToShow) {
        var slidesToShowDesktop = slidesToShow;
        //if not filled in use defaults
        if ((slidesToShowDesktop == 0 || slidesToShowDesktop == null)) {
            slidesToShowDesktop = 4;
        } else if (slidesToShowDesktop == 0 || slidesToShowDesktop == null) {
            slidesToShowDesktop = 3;
        }

        var deviceSlides = this.getNumOfSlidesPerDevice(slidesToShowDesktop);

        return this.getSettingsObject(deviceSlides.slidesToShowDesktop, deviceSlides.slidesToShowTablet, deviceSlides.slidesToShowMobile, 0);
    }
    //slick settings for Resource Listing / Solution Listings / Related Customer Listings -- which creates a slick slider
    SlickSliderSettings.prototype.getSlickSliderResourceListingSettings = function getSlickSliderSettings(slidesToShow) {

        var slidesToShowDesktop = slidesToShow;
        
        //if not filled in use defaults
		if (slidesToShowDesktop == 0) {
			slidesToShowDesktop = 3;
		} 

        var deviceSlides = this.getNumOfSlidesPerDevice(slidesToShowDesktop);

        return this.getSettingsObject(deviceSlides.slidesToShowDesktop, deviceSlides.slidesToShowTablet, deviceSlides.slidesToShowMobile, 0);
    }

    SlickSliderSettings.prototype.getArticleCollectionSettings = function getSlickSliderSettings(slidesToShow) {

        var slidesToShowDesktop = slidesToShow;
        
        //if not filled in use defaults
		if (slidesToShowDesktop == 0) {
			slidesToShowDesktop = 3;
		} 

        var deviceSlides = this.getNumOfSlidesPerDevice(slidesToShowDesktop);

        return this.getSettingsObject(deviceSlides.slidesToShowDesktop, deviceSlides.slidesToShowTablet, deviceSlides.slidesToShowMobile, 1);
    }
    SlickSliderSettings.prototype.getTabsetButtonsSettings = function getSlickSliderSettings(slidesToShow, slidesToShowMobile,touchScreen) {
        if (touchScreen) {
            return {
                draggable: true,
                dots: false,
                infinite: false,
                slidesToShow: slidesToShow,
                slidesToScroll: Math.floor(slidesToShow),
                centerMode: false,
                touchThreshold: 10,
                mobileFirst: false,
                arrows: false,
                variableWidth: true,
                swipeToSlide: true
};
        } else {
            return {
                draggable: false,
                dots: false,
                infinite: false,
                slidesToShow: slidesToShow,
                slidesToScroll: Math.floor(slidesToShow),
                centerMode: false,
                mobileFirst: false,
                arrows: true,
                variableWidth: true,
                responsive: [
                    {
                       breakpoint: 768,
                       settings: {
                           slidesToShow: slidesToShowMobile,
                           slidesToScroll: Math.floor(slidesToShowMobile)
                        }
                   }
                ]
            };
        }
    }

    SlickSliderSettings.prototype.getSlickProductCardSettings = function getSlickProductCardSettings() {
        return {
            draggable: true,
            dots: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            touchThreshold: 10,
            mobileFirst: false,
            responsive: [
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };
    }

    SlickSliderSettings.prototype.getSlickProductComparisonSettings = function getSlickProductComparisonSettings() {
        return {
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            touchThreshold: 0,
            mobileFirst: false,
            draggable: false,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1680,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: Math.floor(2.2083)
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: Math.floor(1.2433)
                    }
                }
            ]
        };
    }

    SlickSliderSettings.prototype.getSettingsObject = function getSettingsObject(slidesToShowDesktop, slidesToShowTablet, slidesToShowMobile, slidesToScroll) { 
        return {
            draggable: true,
            dots: true,
            infinite: false,
            slidesToShow: slidesToShowDesktop,
            slidesToScroll: slidesToScroll == 0 ? Math.floor(slidesToShowDesktop) : slidesToScroll,
            centerMode: false,
            touchThreshold: 10,
            mobileFirst: false,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: { 
                        slidesToShow: slidesToShowDesktop <= 2 ? slidesToShowDesktop : slidesToShowDesktop * 0.9,
                        slidesToScroll: slidesToScroll == 0 ? Math.floor(slidesToShowDesktop) : slidesToScroll,
                        centerMode: false,
                    }
                },
                {
                    breakpoint: 1080,
                    settings: { 
                        slidesToShow: slidesToShowTablet, 
                        slidesToScroll: slidesToScroll == 0 ? Math.floor(slidesToShowTablet) : slidesToScroll,
                        centerMode: false 
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: slidesToShowMobile,
                        slidesToScroll: slidesToScroll == 0 ? Math.floor(slidesToShowMobile) : slidesToScroll,
                        centerMode: false
                    }
                }
            ]
        };
    }

    SlickSliderSettings.prototype.getNumOfSlidesPerDevice = function getNumOfSlidesPerDevice(slidesToShow) { 
        var slidesToShowDesktop = slidesToShow;
        var slidesToShowTablet = 0;
        var slidesToShowMobile = 0;

        if (slidesToShowDesktop >= 6) {
            slidesToShowDesktop = 6; // set max to 6
            slidesToShowTablet = 3.05;
            slidesToShowMobile = 1.5;
        } else if (slidesToShowDesktop == 5) {
            slidesToShowTablet = 2.55;
            slidesToShowMobile = 1.25;
        } else if (slidesToShowDesktop == 4) {
            slidesToShowTablet = 2.05;
            slidesToShowMobile = 1.138;
        } else if (slidesToShowDesktop == 3) {
            slidesToShowTablet = 1.6;
            slidesToShowMobile = 1.138;
        } else if (slidesToShowDesktop == 2) {
            slidesToShowTablet = 1.5;
            slidesToShowMobile = 1.138;
        } else {
            slidesToShowTablet = 1.1;
            slidesToShowMobile = 1.138;
        }

        return { "slidesToShowDesktop" : slidesToShowDesktop, "slidesToShowTablet" : slidesToShowTablet, "slidesToShowMobile" : slidesToShowMobile }
    }

    return new SlickSliderSettings();
});

